export default __webpack_public_path__ + "static/media/welzheim_dark.36e808d8.png";